<template>
  <roe-error-message :field="design.employer_other_integrated_wage_base">
    <input
      name="employer_other_integrated_wage_base"
      type="number"
      v-model.number="design.$model.employer_other_integrated_wage_base"
    />
    <label class="input-label-inside">$</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeEmployerOtherIntegratedWageBaseInput",
  components: { RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
